import { useEffect } from 'react';
import { ErrorBoundary, useErrorHandler } from 'react-error-boundary';
import BarcodePayment from './pages/barcode-payment';
import { analytics, storage } from './app-loader';
import { Button, Loading } from '@autopass-web/mochi-component';
import useAppStore from './app-store';
import useStore from './pages/barcode-payment/store';

export const barcodePaymentMqttAction = {
  payment_token: (mqttAction) => {
    const store = useStore.getState();
    switch (mqttAction.action) {
      case 'receive':
        store.setBarcodeCountdown(true);
        break;
      case 'complete':
        store.setBarcodePaymentResult(mqttAction.options);
        break;
      default:
        return;
    }
  },
};

const ErrorComponent = ({ error }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <h2>發生錯誤</h2>
      <p style={{ marginTop: 15, textAlign: 'center' }}>{error.message}</p>
      <p style={{ margin: 15 }}>請重新整理。</p>
      <Button
        onClick={() => window.location.reload()}
        theme="black"
        type="solid-round"
      >
        我知道了
      </Button>
    </div>
  );
};

const Container = ({ app, env, action }) => {
  const appStore = useAppStore();
  const handleError = useErrorHandler();

  useEffect(() => {
    if (!env.accessToken) return;

    if (app) appStore.setApp(app);
    if (action) appStore.setGlobalAction(action);
    if (env.analyticsKey) analytics.init(env.analyticsKey);
    if (env.userId) analytics.setUserId(env.userId);
    if (env.plate) appStore.setDefaultPlate(env.plate);
    if (env.receipt) appStore.setDefaultReceipt(env.receipt);

    // auth key 與 PBA 相同，因此只需要在其他服務存下 token 即可
    switch (app) {
      case 'client-mochipay':
        appStore.fetchUser(handleError);
        break;
      default:
        storage.saveAuth({ accessToken: env.accessToken });
        appStore.setInit();
    }
  }, [env.analyticsKey, env.accessToken]);

  if (!appStore.init) return <Loading />;

  return <BarcodePayment />;
};

const FeatureBarcodePayment = (props) => {
  return (
    <ErrorBoundary
      FallbackComponent={(fallbackProps) => (
        <ErrorComponent {...fallbackProps} />
      )}
    >
      <Container {...props} />
    </ErrorBoundary>
  );
};

export default FeatureBarcodePayment;
